module.exports = __webpack_public_path__ + "static/media/picture-2@2x.d8d5c325.png";